// extracted by mini-css-extract-plugin
export default {"about":"About_about__+nq7h","content":"About_content__t5Upe"};